(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sc-countdown"] && !Shopify.designMode) return;
  try {
    class ScCountdown extends HTMLElement {
    connectedCallback() {
      this.deadline = new Date(this.dataset.deadline).getTime();

      if (Number.isNaN(this.deadline)) {
        this.hidden = true;
        return;
      }

      this.fields = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = this.deadline - Date.now();

      // The offer is over. Removing the element is the honest end state: leaving
      // a row of zeroes on the page still implies a live promotion.
      if (remaining <= 0) {
        clearInterval(this.timer);
        this.remove();
        return;
      }

      const seconds = Math.floor(remaining / 1000);
      const pad = (value) => String(value).padStart(2, '0');

      this.fields.days.textContent = pad(Math.floor(seconds / 86400));
      this.fields.hours.textContent = pad(Math.floor((seconds % 86400) / 3600));
      this.fields.minutes.textContent = pad(Math.floor((seconds % 3600) / 60));
      this.fields.seconds.textContent = pad(seconds % 60);
    }
  }

  if (!customElements.get('sc-countdown')) {
    customElements.define('sc-countdown', ScCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
